appSocial.filter('currencyConvert', ['SocialConfigurationService',
    function (SocialConfigurationService) {

        class CurrencyConvertPipe {
            constructor() {
                /**
                 * @type SocialConfigurationService
                 */
                this.configurationService = SocialConfigurationService;
            }

            convert(fromCurrency, toCurrency, amount) {
                let conversion;
                if (fromCurrency === toCurrency) {
                    return amount;
                }

                const rates = this.configurationService.get('conversionRates') || [];

                //nonUSD -> USD
                if (fromCurrency !== 'USD' && toCurrency === 'USD') {
                    conversion = _.find(rates, {currency: fromCurrency});
                    if (!conversion) {
                        console.warn(`Conversion currency not found. [${fromCurrency}] -> [${toCurrency}]`);
                        return amount;
                    }
                    return amount * conversion.rate;
                }

                //USD -> nonUSD
                if (fromCurrency === 'USD' && toCurrency !== 'USD') {
                    conversion = _.find(rates, {currency: toCurrency});
                    if (!conversion) {
                        console.warn(`Conversion currency not found. [${fromCurrency}] -> [${toCurrency}]`);
                        return amount;
                    }
                    return amount / conversion.rate;
                }


                //nonUSD -> nonUSD (conversion via USD rate)
                if (fromCurrency !== 'USD' && toCurrency !== 'USD') {
                    //convert src currency to USD
                    conversion = _.find(rates, {currency: fromCurrency});
                    if (!conversion) {
                        console.warn(`Conversion currency not found. [${fromCurrency}] -> [${toCurrency}]`);
                        return amount;
                    }
                    amount = amount * conversion.rate;

                    //convert USD to dst currency
                    conversion = _.find(rates, {currency: toCurrency});
                    if (!conversion) {
                        console.warn(`Conversion currency not found. [${fromCurrency}] -> [${toCurrency}]`);
                        return amount;
                    }
                    amount = amount / conversion.rate;

                    return amount;
                }

                console.warn(`Unpredictable state while converting currency [${fromCurrency}] -> [${toCurrency}]`);
            }
        }
        const pipeInstance = new CurrencyConvertPipe();

        return function (amount, from, to) {
            return pipeInstance.convert(from, to, amount);
        }
    }
])
